import React from 'react';
import PropTypes from 'prop-types';

import css from '../styles/loadingcomponent';

class LoadingComponent extends React.Component {
    static propTypes = {
        height: PropTypes.number,
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { height } = this.props;

        const style = height ? { height } : null;

        return (
            <div className={css.container} style={style}>
                <div className={css.inner}>
                    <div className={css.bounce}>
                        <div className={css.bounce1} />
                        <div className={css.bounce2} />
                    </div>
                </div>
            </div>
        );
    }
}

export default LoadingComponent;



/** WEBPACK FOOTER **
 ** /src/shared/components/LoadingComponent.js
 **/